export default __webpack_public_path__ + "static/section_3_button_2-1ed8747653b3c21761f687e2c2c5bfbf.png";